import { Combobox, Field } from '@reelplicate/ui';
import { useMemo } from 'react';

import { timezoneOptions } from '@/features/settings/timezones';

/** The option that clears the persona's zone (cmdk can't key an item by ""). */
const WORKSPACE = '__workspace';

/**
 * The time zone a persona's posts are scheduled in. Empty uses the
 * workspace's, so a persona only needs one when they live somewhere else.
 */
export function PersonaTimezoneField({
  value,
  onChange,
  workspaceZone,
  error,
  className,
}: {
  /** An IANA zone, or "" for the workspace's. */
  value: string;
  onChange: (value: string) => void;
  /** Named in the "use the workspace's" option, when known. */
  workspaceZone?: string;
  error?: string;
  className?: string;
}) {
  const options = useMemo(
    () => [
      {
        value: WORKSPACE,
        label: workspaceZone
          ? `Workspace time zone (${workspaceZone.replaceAll('_', ' ')})`
          : 'Workspace time zone',
        keywords: ['workspace', 'default'],
      },
      ...timezoneOptions(),
    ],
    [workspaceZone],
  );
  return (
    <Field
      label="Time zone"
      optional
      helper="Their posts are scheduled in it, e.g. 9:00 is 9:00 where they live."
      error={error}
      className={className}
    >
      <Combobox
        options={options}
        value={value || WORKSPACE}
        onValueChange={(next) => onChange(next === WORKSPACE ? '' : next)}
        placeholder="Search time zones"
        emptyTitle={(query) => `No time zone matches “${query}”`}
        aria-label="Time zone"
      />
    </Field>
  );
}
